import { Icons } from "assets";
import classNames from "classnames";
import { useEffect } from "react";
import CustomTextArea from "shared/components/common/customTextArea";
import { GetAppOutcomesService } from "shared/services/questionnaire";
import {
  checkIfComplete,
  getPercentagefromString,
  GetQuestionStatement,
} from "shared/utils/helper";
import styles from "./styles.module.scss";

interface QuestionnaireReviewProps {
  formData: any;
  finalPayload: any;
  setStep: (step: number) => void;
  setLoading: (loading: boolean) => void;
}

const ReviewStep = ({
  formData,
  finalPayload,
  setStep,
  setLoading,
}: QuestionnaireReviewProps) => {
  const handleFormData = async () => {
    try {
      if (checkIfComplete(formData)) {
        let tempData: any[] = [];
        for (let i = 0; i < formData?.length; i++) {
          let job = formData[i];
          if (job?.roleType?.value === "1") {
            let code = `IC | ${job?.q1?.output} - ${job?.q2?.institutionalExpertise?.level}${job?.q3?.culturalImpact?.level} - ${job?.q4?.physicalEnvironment?.level}${job?.q5?.mentalEnvironment?.level} - ${job?.q6?.applicationLevel?.level} - ${job?.q7?.manualEffort?.level} - ${job?.q8?.outcomes?.level}`;
            let q1 = Number(job?.q1?.output);
            let q2 = getPercentagefromString(job?.q2?.output);
            let q3 = getPercentagefromString(job?.q3?.output);
            let q4 = Number(job?.q4?.output);
            let q5 = Number(job?.q5?.output);
            let q6 = getPercentagefromString(job?.q6?.output);
            let q7 = Number(job?.q7?.output);
            let q8 = getPercentagefromString(job?.q8?.output);
            let step1 = Math.round(q1 * q2 * q3);
            let step2 = step1 + (q4 + q5);
            let step3 = Math.round(step2 * q6);
            let step4 = step3 + q7;
            let result = Math.round(step4 * q8);
            let tempObj: any = {
              jobTitle: job?.jobTitle,
              department: job?.department,
              roleType: job?.roleType?.value,
              modifier: job?.q1?.modifier?.value,
              levelOfWork: job?.q1?.levelWork?.value,
              q2: job?.q2?.institutionalExpertise?.value,
              q3: job?.q3?.culturalImpact?.value,
              q4: job?.q4?.physicalEnvironment?.value,
              q5: job?.q5?.mentalEnvironment?.value,
              q6: job?.q6?.applicationLevel?.value,
              q7: job?.q7?.manualEffort?.value,
              q8: job?.q8?.outcomes?.value,
              q9: job?.q9?.notes,
              shortCode: code,
              rasScore: Math.trunc(result),
              rasLevel: 7,
            };
            if (job?.jobCode) {
              tempObj.jobCode = job?.jobCode;
            }
            if (job?.jobGrade) {
              tempObj.jobGrade = job?.jobGrade;
            }
            tempData.push(tempObj);
          } else {
            let code = `M | ${job?.q1?.output} - ${job?.q2?.institutionalExpertise?.level}${job?.q3?.culturalImpact?.level} - ${job?.q4?.physicalEnvironment?.level}${job?.q5?.mentalEnvironment?.level} - ${job?.q6?.applicationLevel?.level} - ${job?.q7?.manualEffort?.level} - ${job?.q8?.outcomes?.level}`;
            let q1 = Number(job?.q1?.output);
            let q2 = getPercentagefromString(job?.q2?.output);
            let q3 = getPercentagefromString(job?.q3?.output);
            let q4 = Number(job?.q4?.output);
            let q5 = Number(job?.q5?.output);
            let q6 = getPercentagefromString(job?.q6?.output);
            let q7 = Number(job?.q7?.output);
            let response = await GetAppOutcomesService({
              level: job?.q6?.applicationLevel?.level,
              outcome: job?.q8?.outcomes?.level,
            });
            let q8 = getPercentagefromString(response?.data?.outcome);
            let step1 = Math.round(q1 * q2 * q3);
            let step2 = step1 + (q4 + q5);
            let step3 = Math.round(step2 * q6);
            let step4 = step3 + q7;
            let result = Math.round(step4 * q8);
            let tempObj: any = {
              jobTitle: job?.jobTitle,
              department: job?.department,
              roleType: job?.roleType?.value,
              modifier: job?.q1?.modifier?.value,
              levelOfWork: job?.q1?.levelWork?.value,
              q2: job?.q2?.institutionalExpertise?.value,
              q3: job?.q3?.culturalImpact?.value,
              q4: job?.q4?.physicalEnvironment?.value,
              q5: job?.q5?.mentalEnvironment?.value,
              q6: job?.q6?.applicationLevel?.value,
              q7: job?.q7?.manualEffort?.value,
              q8: job?.q8?.outcomes?.value,
              q9: job?.q9?.notes,
              shortCode: code,
              rasScore: Math.trunc(result),
            };
            if (job?.jobCode) {
              tempObj.jobCode = job?.jobCode;
            }
            if (job?.jobGrade) {
              tempObj.jobGrade = job?.jobGrade;
            }
            tempData.push(tempObj);
          }
          if (i === formData.length - 1) {
            setLoading(false);
            finalPayload.current = {
              evals: tempData,
            };
          }
        }
      } else {
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    handleFormData();
    // eslint-disable-next-line
  }, [formData]);

  return (
    <div className={classNames(styles.reviewContainer)}>
      <p>Review Your Responses</p>
      {/*<h1>Verify Your Answers</h1>*/}
      <div className={classNames(styles.questionsList)}>
        <div className={classNames(styles.singleQuestionContainer, "gap-4")}>
          <div
            className={classNames(
              styles.titleContaier,
              "flex-col sm:flex-row pb-4"
            )}
          >
            <h2>List the role(s) you would like to evaluate:</h2>
            <div
              className={classNames(styles.iconContainer)}
              onClick={() => {
                setStep(1);
              }}
            >
              <Icons.Pencil />
              <span>Edit</span>
            </div>
          </div>

          {
            //@ts-ignore
            formData?.map((job: any, index: number) => {
              return (
                <div
                  className={classNames("flex flex-col gap-3 overflow-auto")}
                  key={index}
                >
                  {formData.length > 1 && <h3>Job {index + 1}</h3>}
                  <div className={classNames(styles.jobContainer)}>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Job Title</label>
                      <span>{job?.jobTitle}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Department</label>
                      <span>{job?.department}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Job Code</label>
                      <span>{job?.jobCode}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Job Grade</label>
                      <span>{job?.jobGrade}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Role Type</label>
                      <span>{job?.roleType?.name}</span>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
        <div className={classNames(styles.singleQuestionContainer, "gap-4")}>
          <div
            className={classNames(
              styles.titleContaier,
              "flex-col sm:flex-row pb-4"
            )}
          >
            <h2>
              <span>Q1. </span>
              {GetQuestionStatement(1)}
            </h2>
            <div
              className={classNames(styles.iconContainer)}
              onClick={() => {
                setStep(2);
              }}
            >
              <Icons.Pencil />
              <span>Edit</span>
            </div>
          </div>

          {
            //@ts-ignore
            formData?.map((job: any, index: number) => {
              return (
                <div
                  className={classNames("flex flex-col gap-3 overflow-auto")}
                  key={index}
                >
                  {formData?.length > 1 && <h3>Job {index + 1}</h3>}

                  <div className={classNames(styles.jobContainer)}>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Job Title</label>
                      <span>{job?.jobTitle}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Level of Work</label>
                      <span>{job?.q1?.levelWork?.name}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Modifier</label>
                      <span>{job?.q1?.modifier?.name}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>RAS Output</label>
                      <span>{job?.q1?.output ? job?.q1?.output : "0"}</span>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
        <div className={classNames(styles.singleQuestionContainer, "gap-4")}>
          <div
            className={classNames(
              styles.titleContaier,
              "flex-col sm:flex-row pb-4"
            )}
          >
            <h2>
              <span>Q2.</span> {GetQuestionStatement(2)}
            </h2>
            <div
              className={classNames(styles.iconContainer)}
              onClick={() => {
                setStep(3);
              }}
            >
              <Icons.Pencil />
              <span>Edit</span>
            </div>
          </div>

          {
            //@ts-ignore
            formData?.map((job: any, index: number) => {
              return (
                <div
                  className={classNames("flex flex-col gap-3 overflow-auto")}
                  key={index}
                >
                  {formData?.length > 1 && <h3>Job {index + 1}</h3>}
                  <div className={classNames(styles.jobContainer)}>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Job Title</label>
                      <span>{job?.jobTitle}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Institutional Expertise & Scope</label>
                      <span>{job?.q2?.institutionalExpertise?.name}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>RAS Output</label>
                      <span>{job?.q2?.output}</span>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
        <div className={classNames(styles.singleQuestionContainer, "gap-4")}>
          <div
            className={classNames(
              styles.titleContaier,
              "flex-col sm:flex-row pb-4"
            )}
          >
            <h2>
              <span>Q3.</span> {GetQuestionStatement(3)}
            </h2>
            <div
              className={classNames(styles.iconContainer)}
              onClick={() => {
                setStep(4);
              }}
            >
              <Icons.Pencil />
              <span>Edit</span>
            </div>
          </div>

          {
            //@ts-ignore
            formData?.map((job: any, index: number) => {
              return (
                <div
                  className={classNames("flex flex-col gap-3 overflow-auto")}
                  key={index}
                >
                  {formData?.length > 1 && <h3>Job {index + 1}</h3>}
                  <div className={classNames(styles.jobContainer)}>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Job Title</label>
                      <span>{job?.jobTitle}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Cultural Impact & Communication</label>
                      <span>{job?.q3?.culturalImpact?.name}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>RAS Output</label>
                      <span>{job?.q3?.output}</span>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
        <div className={classNames(styles.singleQuestionContainer, "gap-4")}>
          <div
            className={classNames(
              styles.titleContaier,
              "flex-col sm:flex-row pb-4"
            )}
          >
            <h2>
              <span>Q4.</span> {GetQuestionStatement(4)}
            </h2>
            <div
              className={classNames(styles.iconContainer)}
              onClick={() => {
                setStep(5);
              }}
            >
              <Icons.Pencil />
              <span>Edit</span>
            </div>
          </div>

          {
            //@ts-ignore
            formData?.map((job: any, index: number) => {
              return (
                <div
                  className={classNames("flex flex-col gap-3 overflow-auto")}
                  key={index}
                >
                  {formData.length > 1 && <h3>Job {index + 1}</h3>}
                  <div className={classNames(styles.jobContainer)}>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Job Title</label>
                      <span>{job?.jobTitle}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Physical Environment</label>
                      <span>{job?.q4?.physicalEnvironment?.name}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>RAS Output</label>
                      <span>{job?.q4?.output}</span>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
        <div className={classNames(styles.singleQuestionContainer, "gap-4")}>
          <div
            className={classNames(
              styles.titleContaier,
              "flex-col sm:flex-row pb-4"
            )}
          >
            <h2>
              <span>Q5.</span> {GetQuestionStatement(5)}
            </h2>
            <div
              className={classNames(styles.iconContainer)}
              onClick={() => {
                setStep(6);
              }}
            >
              <Icons.Pencil />
              <span>Edit</span>
            </div>
          </div>

          {
            //@ts-ignore
            formData?.map((job: any, index: number) => {
              return (
                <div
                  className={classNames("flex flex-col gap-3 overflow-auto")}
                  key={index}
                >
                  {formData?.length > 1 && <h3>Job {index + 1}</h3>}
                  <div className={classNames(styles.jobContainer)}>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Job Title</label>
                      <span>{job?.jobTitle}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Mental & Emotional Environment</label>
                      <span>{job?.q5?.mentalEnvironment?.name}</span>
                    </div>

                    <div className={classNames(styles.optionContainer)}>
                      <label>RAS Output</label>
                      <span>{job?.q5?.output}</span>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
        <div className={classNames(styles.singleQuestionContainer, "gap-4")}>
          <div
            className={classNames(
              styles.titleContaier,
              "flex-col sm:flex-row pb-4"
            )}
          >
            <h2>
              <span>Q6.</span> {GetQuestionStatement(6)}
            </h2>
            <div
              className={classNames(styles.iconContainer)}
              onClick={() => {
                setStep(7);
              }}
            >
              <Icons.Pencil />
              <span>Edit</span>
            </div>
          </div>

          {
            //@ts-ignore
            formData?.map((job: any, index: number) => {
              return (
                <div
                  className={classNames("flex flex-col gap-3 overflow-auto")}
                  key={index}
                >
                  {formData?.length > 1 && <h3>Job {index + 1}</h3>}
                  <div className={classNames(styles.jobContainer)}>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Job Title</label>
                      <span>{job?.jobTitle}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Application of Knowledge & Skill</label>
                      <span>{job?.q6?.applicationLevel?.name}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>RAS Output</label>
                      <span>{job?.q6?.output}</span>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
        <div className={classNames(styles.singleQuestionContainer, "gap-4")}>
          <div
            className={classNames(
              styles.titleContaier,
              "flex-col sm:flex-row pb-4"
            )}
          >
            <h2>
              <span>Q7.</span> {GetQuestionStatement(7)}
            </h2>
            <div
              className={classNames(styles.iconContainer)}
              onClick={() => {
                setStep(8);
              }}
            >
              <Icons.Pencil />
              <span>Edit</span>
            </div>
          </div>

          {
            //@ts-ignore
            formData?.map((job: any, index: number) => {
              return (
                <div
                  className={classNames("flex flex-col gap-3 overflow-auto")}
                  key={index}
                >
                  {formData?.length > 1 && <h3>Job {index + 1}</h3>}
                  <div className={classNames(styles.jobContainer)}>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Job Title</label>
                      <span>{job?.jobTitle}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Manual Effort</label>
                      <span>{job?.q7?.manualEffort?.name}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>RAS Output</label>
                      <span>{job?.q7?.output}</span>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
        <div className={classNames(styles.singleQuestionContainer, "gap-4")}>
          <div
            className={classNames(
              styles.titleContaier,
              "flex-col sm:flex-row pb-4"
            )}
          >
            <h2>
              <span>Q8.</span> {GetQuestionStatement(8)}
            </h2>
            <div
              className={classNames(styles.iconContainer)}
              onClick={() => {
                setStep(9);
              }}
            >
              <Icons.Pencil />
              <span>Edit</span>
            </div>
          </div>

          {
            //@ts-ignore
            formData?.map((job: any, index: number) => {
              return (
                <div
                  className={classNames("flex flex-col gap-3 overflow-auto")}
                  key={index}
                >
                  {formData?.length > 1 && <h3>Job {index + 1}</h3>}
                  <div className={classNames(styles.jobContainer)}>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Job Title</label>
                      <span>{job?.jobTitle}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>Outcomes</label>
                      <span>{job?.q8?.outcomes?.name}</span>
                    </div>
                    <div className={classNames(styles.optionContainer)}>
                      <label>RAS Output</label>
                      <span>{job?.q8?.output ? job?.q8?.output : 0}</span>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
        <div className={classNames(styles.singleQuestionContainer, "gap-4")}>
          <div
            className={classNames(
              styles.titleContaier,
              "flex-col sm:flex-row pb-4"
            )}
          >
            <h2>
              <span>Q9.</span> Enter any notes or comments for rationale of the
              evaluation.
            </h2>
            <div
              className={classNames(styles.iconContainer)}
              onClick={() => {
                setStep(10);
              }}
            >
              <Icons.Pencil />
              <span>Edit</span>
            </div>
          </div>

          {
            //@ts-ignore
            formData?.map((job: any, index: number) => {
              return (
                <div
                  className={classNames("flex flex-col gap-3 overflow-auto")}
                  key={index}
                >
                  {formData.length > 1 && <h3>Job {index + 1}</h3>}
                  <div className={classNames(styles.jobContainer)}>
                    <CustomTextArea
                      value={job?.q9?.notes}
                      disabled
                      placeholder="Enter Notes / Comments (Optional)"
                    />
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </div>
  );
};

export default ReviewStep;
